import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Color, forLifeOf, LifecycleAware } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';

@LifecycleAware()
@Component({
    selector: 'buyer-configuration-section',
    styleUrls: ['./buyer-configuration-section.component.scss'],
    template: `
        <div class="buyer-configuration-section">
            <div
                [id]="sectionFormControlName + 'SectionHeader'"
                class="section-header"
                (click)="toggleExpanded()"
                [class.hasError]="
                    showDisplay &&
                    !sectionFormGroup.valid &&
                    hasClickedSave &&
                    sectionFormGroup.get(sectionFormControlName).value
                "
            >
                <form *ngIf="showDisplay" [formGroup]="sectionFormGroup">
                    <lsq-switch
                        containerClass="flex-left-to-right"
                        labelOrientation="right"
                        labelClass="text-bold"
                        [id]="sectionFormControlName"
                        [label]="sectionTitle"
                        [name]="sectionFormControlName"
                        [formControlName]="sectionFormControlName"
                        [group]="sectionFormGroup"
                    ></lsq-switch>
                </form>

                <div class="spacing">
                    <label
                        *ngIf="!showDisplay"
                        [ngClass]="'text-bold'"
                        [for]="uniqueId"
                        [innerHTML]="sectionTitle"
                    >
                    </label>
                </div>

                <div class="expand-toggle">
                    <lsq-icon
                        class="sort-caret"
                        [type]="isExpanded ? icons.ChevronDown : icons.ChevronRight"
                        [color]="color.GraphicGray"
                    >
                    </lsq-icon>
                </div>
            </div>
            <div
                [class]="{
                    'section-body': true,
                    open: isExpanded
                }"
            >
                <ng-content></ng-content>
            </div>
        </div>
    `
})
export class AdminBuyerConfigurationSectionComponent implements OnInit, OnDestroy {
    @Input() public sectionTitle: string;
    @Input() public sectionFormControlName: string;
    @Input() public sectionFormGroup: FormGroup;
    @Input() public hasClickedSave: boolean;
    @Input() public showDisplay: boolean = true;

    public isExpanded = false;

    public readonly icons = Icons;
    public readonly color = Color;

    public ngOnInit(): void {
        this.isExpanded = this.showDisplay
            ? !!this.sectionFormGroup.get(this.sectionFormControlName).value
            : false;

        if (this.showDisplay) {
            if (!this.sectionFormGroup.get(this.sectionFormControlName).value) {
                this.sectionFormGroup.disable({ emitEvent: false });
                this.sectionFormGroup.get(this.sectionFormControlName).enable({ emitEvent: false });
            } else {
                this.sectionFormGroup.enable({ emitEvent: false });
            }

            // Toggle the section when turning the section on or off.
            this.sectionFormGroup
                .get(this.sectionFormControlName)
                .valueChanges.pipe(forLifeOf(this))
                .subscribe((enabled) => {
                    this.isExpanded = enabled;

                    // Disable the section fields when section is turned off.
                    if (!enabled && this.showDisplay) {
                        this.sectionFormGroup.disable({ emitEvent: false });
                        this.sectionFormGroup
                            .get(this.sectionFormControlName)
                            .enable({ emitEvent: false });
                    } else {
                        this.sectionFormGroup.enable({ emitEvent: false });
                    }
                });
        }
    }

    public toggleExpanded(): void {
        this.isExpanded = !this.isExpanded;
    }

    public ngOnDestroy(): void {}
}
